import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=0cf87976&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf87976')) {
      api.createRecord('0cf87976', component.options)
    } else {
      api.reload('0cf87976', component.options)
    }
    module.hot.accept("./Access.vue?vue&type=template&id=0cf87976&", function () {
      api.rerender('0cf87976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Access.vue"
export default component.exports